// extracted by mini-css-extract-plugin
module.exports = {"page":"_2291","hd":"_6564"};